import { render } from "./NotificationListModalComponent.vue?vue&type=template&id=798d6f80"
import script from "./NotificationListModalComponent.vue?vue&type=script&lang=js"
export * from "./NotificationListModalComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__